const defaultMenuState = false;

export function menuToggleState(state = defaultMenuState, action) {
    switch (action.type) {
        case 'MENU_TOGGLE':
            return (typeof action.isOpen === 'boolean') ? action.isOpen : !state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./web-app/reducers/nav-reducer.js